export class ActionBlockingResponse {
  text: string;
}
